export default __webpack_public_path__ + "static/midday-052aed5b142f3d00b4bd9d21c98cb949.svg";